import { isOpx } from './isOpx';
import { TEAMS, getOpxHostApp } from 'owa-config';

export function isOpxAndTeams() {
    return isOpx() && getOpxHostApp() === TEAMS;
}
